import ISolicitor from './ISolicitor';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseSolicitor(raw: any): ISolicitor {
    return {
        email: raw.email,
        name: raw.name,
        phone: raw.phone,
        uuid: raw.uuid,
    };
}
